"use strict";
/**
 * Wire format for in-preview text editing of HTML sections. The admin frame
 * drives the mode and pushes style patches; the shopper frame reports selection
 * state and hands back edited markup.
 *
 * Mirrors the inspector protocol in `inspectMessages.ts` — envelopes are
 * validated by the `type` discriminator on the receiving side.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIVE_EDIT_STYLE_PROPS = exports.LIVE_EDIT_MESSAGE_TYPE = void 0;
exports.LIVE_EDIT_MESSAGE_TYPE = {
    /** Parent → iframe. Enter or leave edit mode, and which sections accept edits. */
    SET_MODE: 'live-edit-set-mode',
    /** Parent → iframe. Apply a CSS patch to the stored selection range. */
    APPLY_STYLE: 'live-edit-apply-style',
    /**
     * Parent → iframe. A toolbar control is open and about to take focus, so
     * the preview should keep the selection it is being pointed at rather than
     * treating the blur as the user moving on.
     */
    SET_HOLD: 'live-edit-set-hold',
    /** Iframe → parent. Focus entered editable content. */
    SESSION_START: 'live-edit-session-start',
    /** Iframe → parent. Selection moved; drives the floating toolbar. */
    SELECTION: 'live-edit-selection',
    /** Iframe → parent. An edited element is ready to be written back. */
    COMMIT: 'live-edit-commit',
    /**
     * Iframe → parent. A section that cannot be edited in place was clicked,
     * so the editor should open that section's panel instead.
     */
    SECTION_PICK: 'live-edit-section-pick',
    /** Iframe → parent. Focus left editable content; every commit has been sent. */
    SESSION_END: 'live-edit-session-end',
    /** Iframe → parent. Undo/redo pressed while editing; the editor owns the stack. */
    HISTORY: 'live-edit-history',
};
/**
 * CSS properties the floating toolbar can write. Constrained on purpose: these
 * are the ones that read back reliably from `getComputedStyle`, which is how
 * the toolbar resolves its active state.
 */
exports.LIVE_EDIT_STYLE_PROPS = [
    'font-family',
    'font-size',
    'font-weight',
    'font-style',
    'line-height',
    'text-decoration-line',
    'color',
    'background-color',
];
